const REBOOKING_TIME_LIMIT_MS = ((3 * 60) + 10) * 60 * 1000 // 3 hours and 10 minutes in milliseconds

export const isWithinRebookingWindow = departure => {
	let diff = new Date(departure).getTime() - new Date().getTime()

	if (diff < 0) {
		diff = diff * -1
	}

	return diff <= REBOOKING_TIME_LIMIT_MS
}

export const isOutsideRebookingWindow = departure => {
	let diff = new Date(departure).getTime() - new Date().getTime()

	if (diff < 0) {
		diff = diff * -1
	}

	return diff >= REBOOKING_TIME_LIMIT_MS
}

export const has150DaysPassed = date => {
	let differenceInMilliseconds = new Date() - new Date(date)

	if (differenceInMilliseconds < 0) {
		differenceInMilliseconds = differenceInMilliseconds * -1
	}

	const differenceInDays = differenceInMilliseconds / (1000 * 60 * 60 * 24)
	return differenceInDays > 150
}

export const checkAge = date => {
	if (!date) return false

	const birthDate = new Date(date)
	const today = new Date()

	const age = today.getFullYear() - birthDate.getFullYear()
	const monthDiff = today.getMonth() - birthDate.getMonth()
	const dayDiff = today.getDate() - birthDate.getDate()

	// Ajusta caso o aniversário ainda não tenha ocorrido este ano
	const adjustedAge =
		monthDiff < 0 || (monthDiff === 0 && dayDiff < 0) ? age - 1 : age

	return adjustedAge >= 2 && adjustedAge <= 90
}
